import * as Styles from './List.styles';
import React from 'react';
import { ListItem } from './components/ListItem';
import { Tag } from 'gatorcomponents';

const List = ({
  available,
  searchedDomain,
  locales,
  domainsList,
  freeDomains,
  checkedItems,
  setCheckedItems,
}) => (
  <Styles.ListWrapper data-testid="buy-domain-list">
    {(!available && !!domainsList.length) && (
      <ListItem
        available={false}
        searchedDomain={searchedDomain}
        locales={locales}
        freeDomains={freeDomains}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
      />
    )}

    {domainsList.map((domain) => {
      const keys = Object.keys(domain.cycle);
      const values = Object.values(domain.cycle);

      const validEntries = keys.map((key, index) => ({ key, value: values[index] }))
        .filter((entry) => {
          if (!entry.value) {
            return false;
          }
          const price = parseFloat(entry.value.priceRegister);
          return price >= 0;
        });

      if (validEntries.length === 0) {
        return null;
      }

      const options = validEntries.map((entry) => {
        const discount = entry.value && parseFloat(entry.value.discount);
        const hasValidDiscount = !Number.isNaN(discount) && discount > 0;

        return {
          value: entry.key,
          label: (
            <>
              {`${locales.optionsCycle[entry.key]} ${locales.optionsCycle.year(locales.optionsCycle[entry.key])}`}
              {hasValidDiscount && (
                <Tag variant="active" size="sm" label={`${entry.value.discount}% OFF`} />
              )}
            </>
          ),
        };
      });

      const protectIdData = domain.related && domain.related[0];

      return (
        <React.Fragment key={domain.name}>
          <ListItem
            available
            domain={domain}
            locales={locales}
            freeDomains={freeDomains}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            options={options}
            protectIdData={protectIdData}
          />
        </React.Fragment>
      );
    })}
  </Styles.ListWrapper>
);

export default List;
